export interface IQrTicket {
  qrticketId: number;
  ticketNameJp: string;
  ticketNameEn: string;
  limitMonthDate: Date;
  mdTdTicketTypeName: string;
  qrseqNo: number;
  qrcode: string;
  ticketReserveStatus: string;
  ticketReserveStatusEnum: string;
  ticketReserveStatusName: string;
  ticketReserveTime?: Date;
  ticketEnterStatus: string;
  ticketEnterStatusEnum: string;
  ticketEnterStatusName: string;
  startTime1?: Date;
  deleteFlagEnum: string;
}

export interface IQrTicketFilters {
  salesId?: number;
  qrSeqNo?: string;
  ticketReserveTimeFrom?: Date;
  ticketReserveTimeTo?: Date;
  startTimeFrom?: Date;
  startTimeTo?: Date;
  ticketReserveStatus?: string;
  ticketReserveStatusName?: string;
  ticketEnterStatus?: string;
  ticketEnterStatusName?: string;
}

export class QrTicketFiltersFormValues implements IQrTicketFilters {
  salesId?: number = undefined;
  qrSeqNoFrom?: string = undefined;
  qrSeqNoTo?: string = undefined;
  ticketReserveTimeFrom?: Date = undefined;
  ticketReserveTimeTo?: Date = undefined;
  startTimeFrom?: Date = undefined;
  startTimeTo?: Date = undefined;
  ticketReserveStatus?: string = undefined;
  ticketReserveStatusName?: string = undefined;
  ticketEnterStatus?: string = undefined;
  ticketEnterStatusName?: string = undefined;

  constructor(init?: IQrTicketFilters) {
    Object.assign(this, init);
  }
}
